import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import TextTemplate from '../RegistrationParts/TextSlideTemplate'

export default class extends React.Component {
    static propTypes = {
		nextSlide: PropTypes.func,
		loginOnly: PropTypes.bool
	};

    render() {

		var content = this.props.loginOnly 
			? <div>
				<h4 className="text-center text-white mbot40">Complete your Registration</h4>
				<p className="text-center text-white mbot30">Oops, it looks like you haven’t completed the registration process.</p>
				<p className="text-center text-white mbot30">Follow the steps and Five to Nine Club will build an experience just for you. See you on the other side.</p>
			</div>
			: <div>
				<h4 className="text-center text-white mbot40">Welcome to Five to Nine Club</h4>
				<p className="text-center text-white mbot30">Before we throw you into an empty, generic Five to Nine Club, we would like to ask a few questions to make sure that we are providing you with the right stuff to help you hit your goals.</p>
				<p className="text-center text-white mbot30">We have a handful of simple questions that won't hurt, but will make your time with Five to Nine Club much more productive.</p>
			</div>;

		return (
			<TextTemplate 
				title={<i className="icon icon-star text-light-danger"></i>}
				content={content}
				continue={this.props.loginOnly ? "Continue" : "Let's get started!" }
				nextSlide={this.props.nextSlide}
				/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/WelcomeSlidePart.jsx